import React from 'react';

import { ContractToolbar, ContractList } from 'views/Contract/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContractToolbar />
      <div className={classes.content}>
        <ContractList />
      </div>
    </div>
  );
};
